import { render, staticRenderFns } from "./DownLinkDataDetails.vue?vue&type=template&id=15fa229a&scoped=true&"
import script from "./DownLinkDataDetails.vue?vue&type=script&lang=js&"
export * from "./DownLinkDataDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fa229a",
  null
  
)

export default component.exports